import * as TooltipPrimitives from "@radix-ui/react-tooltip";
import { cn } from "@theprelude/core";

export const Tooltip = TooltipPrimitives.Tooltip;
export const TooltipTrigger = TooltipPrimitives.TooltipTrigger;

export const TooltipProvider: React.FC<
  TooltipPrimitives.TooltipProviderProps
> = ({ children, delayDuration = 300, ...props }) => {
  return (
    <TooltipPrimitives.TooltipProvider delayDuration={delayDuration} {...props}>
      {children}
    </TooltipPrimitives.TooltipProvider>
  );
};

export const TooltipContent: React.FC<
  TooltipPrimitives.TooltipContentProps
> = ({ children, className, sideOffset = 8, ...props }) => {
  return (
    <TooltipPrimitives.Portal>
      <TooltipPrimitives.Content
        {...props}
        sideOffset={sideOffset}
        className={cn(
          "data-[state=closed]:fade-out-0 fade-in-0 data-[state=closed]:zoom-out-95 zoom-in-95 data-[side=bottom]:slide-in-from-bottom-2 data-[side=top]:slide-in-from-top-2 data-[side=left]:slide-in-from-left-2 data-[side=right]:slide-in-from-right-2 z-50 max-h-[var(--radix-tooltip-content-available-height)] max-w-[var(--radix-tooltip-content-available-width)] animate-in overflow-hidden rounded border border-stroke-line bg-surface-background p-3 text-center data-[state=closed]:animate-out",
          className,
        )}
      >
        {children}
      </TooltipPrimitives.Content>
    </TooltipPrimitives.Portal>
  );
};

export const TooltipArrow: React.FC<TooltipPrimitives.TooltipArrowProps> = ({
  className,
  ...props
}) => {
  return (
    <TooltipPrimitives.Arrow
      {...props}
      className={cn("fill-surface-background", className)}
    />
  );
};
